<template>
  <Card :title="cardTitle" class="flex-fill mt-4">
    <table class="table table-striped table-borderless" id="integrationTable">
      <tbody>
      <tr @click="goToUrl(`${cpixdomain}/aspen/socialSetupWizardConnect.htm?objectType=${getEntity()}`)">
        <th scope="row"><span class="badge badge-pill mr-3" :class="['badge-' + this.integrations.facebook.classText,
                        'badge-' + this.integrations.facebook.classText, 'text-' + this.integrations.facebook.classText]">i</span><span class="platformText" ignore>Facebook</span></th>
        <td :class="'platformStatus text-' + this.integrations.facebook.classText">{{ this.integrations.facebook.statusText }}</td>
      </tr>
      <tr @click="goToUrl(`${cpixdomain}/aspen/socialSetupWizardConnect.htm?objectType=${getEntity()}`)">
        <th scope="row"><span class="badge badge-pill mr-3" :class="['badge-' + this.integrations.twitter.classText,
                        'badge-' + this.integrations.twitter.classText, 'text-' + this.integrations.twitter.classText]">i</span><span class="platformText" ignore>Twitter</span></th>
        <td :class="'platformStatus text-' + this.integrations.twitter.classText">{{ this.integrations.twitter.statusText }}</td>
      </tr>
      <tr @click="goToUrl(`${cpixdomain}/aspen/socialSetupWizardConnect.htm?objectType=${getEntity()}`)">
        <th scope="row"><span class="badge badge-pill mr-3" :class="['badge-' + this.integrations.linkedin.classText,
                        'badge-' + this.integrations.linkedin.classText, 'text-' + this.integrations.linkedin.classText]">i</span><span class="platformText" ignore>LinkedIn</span></th>
        <td :class="'platformStatus text-' + this.integrations.linkedin.classText">{{ this.integrations.linkedin.statusText }}</td>
      </tr>
      <tr @click="goToUrl(`${cpixdomain}/aspen/socialSetupWizardConnect.htm?objectType=${getEntity()}`)">
        <th scope="row"><span class="badge badge-pill mr-3" :class="['badge-' + this.integrations.youtube.classText,
                        'badge-' + this.integrations.youtube.classText, 'text-' + this.integrations.youtube.classText]">i</span><span class="platformText" ignore>YouTube</span></th>
        <td :class="'platformStatus text-' + this.integrations.youtube.classText">{{ this.integrations.youtube.statusText }}</td>
      </tr>
      <tr @click="goToUrl(`${cpixdomain}/aspen/socialSetupWizardConnect.htm?objectType=${getEntity()}`)">
        <th scope="row"><span class="badge badge-pill mr-3" :class="['badge-' + this.integrations.blogger.classText,
                        'badge-' + this.integrations.blogger.classText, 'text-' + this.integrations.blogger.classText]">i</span><span class="platformText" ignore>Blogger</span></th>
        <td :class="'platformStatus text-' + this.integrations.blogger.classText">{{ this.integrations.blogger.statusText }}</td>
      </tr>
      <tr v-if="showChatIntegration" @click="goToUrl(`${cpixdomain}/aspen/chatPreference.htm`)">
        <th scope="row"><span class="badge badge-pill mr-3" :class="['badge-' + this.integrations.chat.classText,
                        'badge-' + this.integrations.chat.classText, 'text-' + this.integrations.chat.classText]">i</span><span class="platformText">Tour Chat</span></th>
        <td :class="'platformStatus text-' + this.integrations.chat.classText">{{ this.integrations.chat.statusText }}</td>
      </tr>
      </tbody>
    </table>
  </Card>
</template>
<script>

  import {cpixdomain} from "../config";
  import Card from './Card';
  import {mapGetters} from 'vuex';

  export default {
    name: 'IntegrationsCard',
    components: {
      Card
    },
    data: function () {
      return {
        integrations: {
          "facebook": {
            "connected": 0,
            "is_valid": 0,
            "expiration_date": 0,
            "statusText": "Not Connected",
            "classText": "danger"
          },
          "twitter": {
            "accounts": {},
            "connected": 0,
            "statusText": "Not Connected",
            "classText": "danger"
          },
          "linkedin": {
            "connected": 0,
            "is_valid": 0,
            "expiration_date": 0,
            "statusText": "Not Connected",
            "classText": "danger"
          },
          "youtube": {
            "accounts": {},
            "connected": 0,
            "statusText": "Not Connected",
            "classText": "danger"
          },
          "blogger": {
            "connected": 0,
            "is_valid": 0,
            "statusText": "Not Connected",
            "classText": "danger"
          },
          "chat": {
            "connected": 0,
            "statusText": "Not Connected",
            "classText": "danger"
          }
        }
      }
    },
    methods: {
      goToUrl: function (link) {
        window.open(link);
      },
      getEntity() {
        if (this.me.isImpersonated) {
          return this.$helpers.capitalizeFirstLetter(this.me.impersonated.loggedInAs)
        } else {
          return this.$helpers.capitalizeFirstLetter(this.me.tokenUser.loggedInAs)
        }
      },
    },
    computed: {
      ...mapGetters(['me']),
      cpixdomain() {
        return cpixdomain
      },
      cardTitle() {

        if (this.me.isImpersonated && this.me.impersonated.loggedInAs !== 'realtor') {
          return this.$helpers.capitalizeFirstLetter(this.me.impersonated.loggedInAs) + ' Integrations'
        }

        return 'Integrations'
      },
      showChatIntegration() {
          if(this.me.isImpersonated) {
              return this.$helpers.get(['loggedInAs'],this.me.impersonated) === 'realtor'
          }

          return this.me.tokenUser.loggedInAs === "realtor"
      }
    },
    mounted: function () {
      this.$http.get("/tokens/")
        .then(res => {
          this.integrations = res.data;
          let expirationWindowMs = 1209600; //seconds in two weeks
          let currentTimestamp = new Date().getTime() / 1000; //convert from ms

          let facebook = this.integrations.facebook;
          if (facebook.connected) {
            if (!facebook.is_valid) {
              facebook.classText = 'warning';
              facebook.statusText = 'Needs Attention';
            } else {
              facebook.classText = 'success';
              facebook.statusText = 'Connected';

              if (typeof facebook.expiration_date !== 'undefined' && facebook.expiration_date != 0) {
                let fbExpirationDate = facebook.expiration_date;
                let fbTimeLeft = (fbExpirationDate - currentTimestamp);

                if (fbTimeLeft <= 0) {
                  facebook.classText = 'warning';
                  facebook.statusText = 'Needs Attention';
                }

                if (fbTimeLeft > 0 && fbTimeLeft < expirationWindowMs) {
                  facebook.classText = 'warning';
                  facebook.statusText = 'Expiring Soon';
                }
              }
            }
          } else {
            facebook.classText = 'danger';
            facebook.statusText = 'Not Connected';
          }

          let twitter = this.integrations.twitter;
          if (twitter.connected) {
            twitter.classText = 'success';
            twitter.statusText = 'Connected';
            let tuas = Object.values(twitter.accounts);
            for (let tua of tuas) {
              if (!tua.is_valid) {
                twitter.classText = 'warning';
                twitter.statusText = 'Needs Attention';
                break;
              }
            }
          } else {
            twitter.classText = 'danger';
            twitter.statusText = 'Not Connected';
          }

          let linkedin = this.integrations.linkedin;
          if (linkedin.connected) {
            if (!linkedin.is_valid) {
              linkedin.classText = 'warning';
              linkedin.statusText = 'Needs Attention';
            } else {
              linkedin.classText = 'success';
              linkedin.statusText = 'Connected';

              if (typeof linkedin.expiration_date !== 'undefined') {
                let liExpirationDate = linkedin.expiration_date;
                let liTimeLeft = (liExpirationDate - currentTimestamp);

                if (liTimeLeft <= 0) {
                  linkedin.classText = 'warning';
                  linkedin.statusText = 'Needs Attention';
                }

                if (liTimeLeft > 0 && liTimeLeft < expirationWindowMs) {
                  linkedin.classText = 'warning';
                  linkedin.statusText = 'Expiring Soon';
                }
              }
            }
          } else {
            linkedin.classText = 'danger';
            linkedin.statusText = 'Not Connected';
          }

          let youtube = this.integrations.youtube;
          if (youtube.connected) {
            youtube.classText = 'success';
            youtube.statusText = 'Connected';
            let googleTokens = Object.values(youtube.accounts);
            for (let googleToken of googleTokens) {
              if (!googleToken.is_valid) {
                youtube.classText = 'warning';
                youtube.statusText = 'Needs Attention';
                break;
              }
            }
          } else {
            youtube.classText = 'danger';
            youtube.statusText = 'Not Connected';
          }

          let blogger = this.integrations.blogger;
          if (blogger.connected) {
            if (!blogger.is_valid) {
              blogger.classText = 'warning';
              blogger.statusText = 'Needs Attention';
            } else {
              blogger.classText = 'success';
              blogger.statusText = 'Connected';
            }
          } else {
            blogger.classText = 'danger';
            blogger.statusText = 'Not Connected';
          }

          let chat = this.integrations.chat;
          if (chat.connected) {
            chat.classText = 'success';
            chat.statusText = 'Connected';
          } else {
            chat.classText = 'warning';
            chat.statusText = 'Needs Attention';
          }
        });
    }
  }
</script>

<style>
  .platformText {
    display: inline-block;
    width: 70%;
  }

  .platformStatus {
    width: 30%;
  }

  #integrationTable td, #integrationTable th {
    padding: 6px;
    cursor: pointer;
  }

  .badge-success {
    background: #90c341 !important
  }

  .badge-danger {
    background: #dc3545 !important
  }


</style>